// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ll-z","tupacHeader":"ml-z","tupacHeader2":"nl-z","tupacMenu":"ol-z","tupacMenu2":"pl-z","tupacMain":"ql-z","tupacMain2":"rl-z"};